import { h, Component } from 'preact';
import { once } from 'utils/utils';
import Store from 'store/store';
// import s from 'components/bolt/vimeo/vimeo.sss';

export default class Vimeo extends Component {
	constructor(props) {
		super(props);

		this.onLoad = once(this.onLoad.bind(this));
		this.onEnded = once(this.onEnded.bind(this));
		this.onProgress = this.onProgress.bind(this);

		this.progressTracking = {};
	}

	componentDidMount() {
		const { videoId } = this.props;
		this.initVimeo(videoId);
	}

	componentWillUnmount() {
		if (!this.player) {
			return;
		}

		this.player.off('loaded');
		this.player.off('timeupdate');
		this.player.off('ended');
		this.player.destroy();
	}

	initVimeo(videoId) {
		if (typeof window === 'undefined') {
			return;
		}
		if (window.Vimeo && window.Vimeo.Player) {
			return this.loadPlayer(videoId);
		}
		if (!window.VimeoLoader) {
			window.VimeoLoader = new Promise((resolve, reject) => {
				const tag = document.createElement('script');
				tag.src = 'https://player.vimeo.com/api/player.js';
				document.body.appendChild(tag);
				tag.onload = resolve;
				tag.onerror = reject;
			});
		}
		return window.VimeoLoader.then(() => {
			this.loadPlayer(videoId);
		});
	}

	loadPlayer(videoId) {
		const vimeoIframe = document.getElementById(videoId);

		if (!vimeoIframe) return;

		this.player = new window.Vimeo.Player(vimeoIframe);
		this.player.on('loaded', this.onLoad);
		this.player.on('ended', this.onEnded);
		this.player.on('timeupdate', this.onProgress);
	}

	onLoad() {
		const { autoplay, onPlayerReady } = this.props;
		if (typeof onPlayerReady === 'function') {
			onPlayerReady();
		}
		if (autoplay) {
			this.player.play();
		}
	}

	onEnded() {
		const { onEnded } = this.props;
		if (onEnded) {
			onEnded();
		}
	}

	onProgress({ percent }) {
		let step = [0, 25, 50, 75, 95].find(step => percent > (step / 100) && !this.progressTracking[step]);

		if (step || step === 0) {
			this.progressTracking[step] = true;
			Store.emit('VIDEO_PLAYER_PROGRESS', {
				step,
				video: this.props.videoId,
				platform: 'vimeo',
				isShowtimesMessage: this.props.isShowtimesMessage,
				isTrailerOverlay: this.props.isTrailerOverlay,
				isTrailer: this.props.isTrailer
			});
		}
	}

	render(props) {
		const { videoId, videoHash } = props;

		return (
			<iframe
				id={videoId}
				hash={videoHash}
				src={`https://player.vimeo.com/video/${videoId}?h=${videoHash}`}
				frameborder="0"
				allow="autoplay"
				fullscreen
				allowfullscreen
			/>
		);
	}
}